export const API_GET_ALL_CONTACT_COMMENT = 'API_GET_ALL_CONTACT_COMMENT'
export const API_GET_ALL_CONTACT_COMMENT_SUCCESS = 'API_GET_ALL_CONTACT_COMMENT_SUCCESS'
export const API_GET_ALL_CONTACT_COMMENT_FAIL = 'API_GET_ALL_CONTACT_COMMENT_FAIL'

export const API_ADMIN_GET_ALL_CONTACT_COMMENT = 'API_ADMIN_GET_ALL_CONTACT_COMMENT'
export const API_ADMIN_GET_ALL_CONTACT_COMMENT_SUCCESS = 'API_ADMIN_GET_ALL_CONTACT_COMMENT_SUCCESS'
export const API_ADMIN_GET_ALL_CONTACT_COMMENT_FAIL = 'API_ADMIN_GET_ALL_CONTACT_COMMENT_FAIL'

export const API_ADMIN_GET_CONTACT_COMMENT = 'API_ADMIN_GET_CONTACT_COMMENT'
export const API_ADMIN_GET_CONTACT_COMMENT_SUCCESS = 'API_ADMIN_GET_CONTACT_COMMENT_SUCCESS'
export const API_ADMIN_GET_CONTACT_COMMENT_FAIL = 'API_ADMIN_GET_CONTACT_COMMENT_FAIL'

export const API_ADMIN_POST_CONTACT_COMMENT = 'API_ADMIN_POST_CONTACT_COMMENT';
export const API_ADMIN_POST_CONTACT_COMMENT_SUCCESS = 'API_ADMIN_POST_CONTACT_COMMENT_SUCCESS';
export const API_ADMIN_POST_CONTACT_COMMENT_FAIL = 'API_ADMIN_POST_CONTACT_COMMENT_FAIL';

export const API_ADMIN_PATCH_CONTACT_COMMENT = 'API_ADMIN_PATCH_CONTACT_COMMENT';
export const API_ADMIN_PATCH_CONTACT_COMMENT_SUCCESS = 'API_ADMIN_PATCH_CONTACT_COMMENT_SUCCESS';
export const API_ADMIN_PATCH_CONTACT_COMMENT_FAIL = 'API_ADMIN_PATCH_CONTACT_COMMENT_FAIL';

export const API_ADMIN_DELETE_CONTACT_COMMENT = 'API_ADMIN_DELETE_CONTACT_COMMENT';
export const API_ADMIN_DELETE_CONTACT_COMMENT_SUCCESS = 'API_ADMIN_DELETE_CONTACT_COMMENT_SUCCESS';
export const API_ADMIN_DELETE_CONTACT_COMMENT_FAIL = 'API_ADMIN_DELETE_CONTACT_COMMENT_FAIL';

export const ADMIN_INIT_NEW_CONTACT_COMMENT = 'ADMIN_INIT_NEW_CONTACT_COMMENT'

export const ADMIN_RESET_FOCUS_CONTACT_COMMENT = 'ADMIN_RESET_FOCUS_CONTACT_COMMENT'